import { module } from 'angular';
import templateBuilderPostalAddressDisplay from './builder/display.html';
import templateBuilderPostalAddressValidate from './builder/validate.html';

export default module('app').run(/* @ngInject */ (
	/** @type {import('angular').ITemplateCacheService} */ $templateCache,
) => {
	$templateCache.put('kform/components/postal-address/display.html', templateBuilderPostalAddressDisplay);
	$templateCache.put('kform/components/postal-address/validate.html', templateBuilderPostalAddressValidate);
});
